module.exports = __webpack_public_path__ + "static/skyrider-sword-2b3176c4bc0033e2d691ca0c8adf2d4b.png";